export const PHASES = {
  FROM: 'FROM',
  TO: 'TO',
}

export const TYPES = {
  QUARTER: 'quarter',
  MONTH: 'month',
}
